

<span [ngClass]="{'_load-animate _load-active': loading}">
  <div class="module-bar-fixed" style="background-color: #fff;">
    <button mat-icon-button (mousedown)="cancel()">
      <mat-icon svgIcon="arrow_next" class="rotate-ltr"></mat-icon>
    </button>
    <span class="title text-truncate">
      <div>{{'OAT.manage_tab_title' | translate}}</div>
    </span>
  </div>



  <div class="module-body-fixed px-3">
    @if(activeTab) {
      <div style="display: flex; flex-direction: column; gap:1.5rem; padding-top:1rem"><div class="alt-panel">
        <div class="alt-panel-body">
          <div class="basket-summary-row">
            <div class="_title">{{ 'order_balance' | translate }}</div>
            <div class="_price text-highlight">{{ $storage.order.total | lcurrency:'0.2-2' }}</div>
          </div>
          @if (!$storage.order.tabLimitUnlimitted) {
            <div class="basket-summary-row">
              <div class="_title">{{ 'OAT.current_preauth' | translate }}</div>
              <div class="_price text-highlight">{{ $storage.order.tabLimit | lcurrency }}</div>
            </div>
            <div class="basket-summary-row">
              <div class="_title">{{ 'OAT.remaining_preauth' | translate }}</div>
              <div
              class="_price text-highlight">{{ ($storage.order.tabLimit - $storage.order.balanceDue) | lcurrency }}</div>
            </div>
          }
        </div>
      </div>

      @if (!$storage.order.tabLimitUnlimitted) {
        <form #f="ngForm" [formGroup]="addToLimitForm" class="condensed-fields">
          <mat-form-field appearance="fill" color="accent">
            <mat-label>{{ 'OAT.increase_amount_limit' | translate }}</mat-label>
            <input name="amountLimit" matInput formControlName="amountLimit" required type="number"
              inputmode="numeric" [min]="minAmount" [max]="maxAmount"/>
              <span matTextSuffix>$</span>

              <!--<mat-hint>{{amountText}}</mat-hint>-->
              @if (amountLimit?.hasError('min') || amountLimit?.hasError('max')) {
                <mat-error>{{ amountText }}</mat-error>
              }
              <mat-hint><small
              class="text-muted">{{ 'OAT.increase_amount_limit_desc' | translate }}</small></mat-hint>
            </mat-form-field>


            <div class="pmamount-rows mt-2">
              @for (opt of addToLimitDenoms; track opt) {
                <button type="button" class="btn-bordered"
                  (click)="addToAmountLimit(opt)">
                  <div>
                    <div class="text-base">
                      +{{ opt | lcurrency:'0.0-0' }}
                    </div>
                  </div>
                </button>
              }
            </div>

            <button mat-flat-button color="primary" class="lg btn-block rounded mt-3"
              [disabled]="!amountLimit.valid" type="button"
              (mousedown)="addAmountLimit()">
              {{ 'OAT.increase_amount_limit' |translate }}
            </button>
          </form>
        }

        @if (base.reviewItemsBeforeSending) {
          <div class="my-panel-info px-1 border">
            <div class="d-flex" style="gap:16px; font-size: 13px">
              <mat-checkbox class="example-margin" [(ngModel)]="changes.reviewItemsBeforeSending" disabled>
                <div>
                  <div class="fw-bold mb-1">{{ 'OAT.review_before_sending_title' | translate }}</div>
                  <div>{{ 'OAT.review_before_sending_info' | translate }}</div>
                </div>
              </mat-checkbox>
            </div>
          </div>
        }

        <div class="text-center">
          <button mat-stroked-button color="accent" class="lg rounded" type="button"
            (mousedown)="dialogsService.passOrder();">
            <mat-icon svgIcon="paper_plane" style="line-height: 15px;"></mat-icon>
            {{ 'OAT.share_my_tab' | translate }}
          </button>
        </div></div>

        <div class="fixed-bottom p-3" >
          <button mat-flat-button color="accent" class="lg btn-block rounded" (mousedown)="closeTab();">
            {{ 'OAT.close_my_tab' | translate }}
          </button>
        </div>
      } @else {
        <button mat-flat-button color="accent" class="lg rounded btn-block" type="button" (mousedown)="addNewTabLimit()">
          {{'OAT.add_new_tab_limit' |translate}}
        </button>
        <app-power-by-tabit></app-power-by-tabit>
      }
    </div>
  </span>





